import React, { ReactElement } from 'react';

import FeatureGridItem from '@components/feature-grid-item';
import Grid from '@components/grid';
import Container from '@components/ui/container';

// TODO types

export default function DualColumnFeaturesGrid(block: any): ReactElement {
  const { items, options } = block;

  const { hideDescription } = options;

  return (
    <Container>
      <Grid>
        {items.map((option: any, idx: number) => (
          <FeatureGridItem
            key={`features--key-${option.id}`}
            idx={idx}
            title={option.title}
            description={option.description}
            hideDescription={hideDescription}
            image={option.image}
          />
        ))}
      </Grid>
    </Container>
  );
}
